import core from '../modules/core';
import store from '@/store/store'
import utils from '@/utils/utils'

export default {
  getMacAddress(parameters={}) {
    return core.call({
      url: '/api/v1/beacon/getMacAddress',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid"),
        'blockYn': 'Y'
      }    
    }); 
  }
}

